<template>
  <DBox
    :id="'cmp-booking-venues-sidewindow-venue-booking'"
    :addButton="false"
    :addLink="false"
    :searchButton="true"
    :searchFlag="searchFlag"
    :badgeButtons="
      filterExists
        ? [
            {
              text: 'Reset Filters',
              value: 'reset_filters',
              icon: 'delete-white'
            }
          ]
        : []
    "
    @badgeClick="onBadgeClick"
    @searchClick="onSearchClick"
  >
    <div v-if="searchFlag" class="ut-flex ut-jbetween">
      <div class="search-controls ut-flex">
        <TextField
          type="date"
          :id="'from_date'"
          class="m1"
          :placeholder="$t('from')"
          :value="filter.from_date"
          :showImmediate="true"
          autocomplete="off"
          :box="false"
          :style="{
            width: '138px'
          }"
          @valuechanged="dateChanged"
        />
        <TextField
          type="date"
          :id="'to_date'"
          class="m1"
          :placeholder="$t('to')"
          :value="filter.to_date"
          :showImmediate="true"
          autocomplete="off"
          :box="false"
          :style="{
            width: '138px'
          }"
          @valuechanged="dateChanged"
        />
        <Dropdown
          :options="statusTV"
          :placeholder="$t('status')"
          :selected="statusTV.find(e => e.value == filter.booking_status_id)"
          v-on:selectedChange="e => onDropdownChange('status', e)"
          deselect
          borderbottom
          :style="{
            width: '138px'
          }"
        ></Dropdown>
        <Dropdown
          :options="promotersTV"
          :placeholder="$t('contact_promoter')"
          :selected="promotersTV.find(e => e.value == filter.promoter_id)"
          v-on:selectedChange="e => onDropdownChange('promoter', e)"
          deselect
          borderbottom
          :style="{
            width: '158px'
          }"
        ></Dropdown>
        <Dropdown
          :options="artistsTV"
          :placeholder="$t('artist_filter')"
          :selected="artistsTV.find(e => e.value == filter.artist_id)"
          v-on:selectedChange="e => onDropdownChange('artist', e)"
          deselect
          borderbottom
          :style="{
            width: '138px'
          }"
        ></Dropdown>
      </div>
      <button @click="onApplyFilter" class="dt-button dt-button v5 s8 m8">
        {{$t("apply_filter")}}
      </button>
    </div>
    <div
      class="ut-fh"
      :style="{
        height: this.searchFlag ? `calc(100% - 52px)` : undefined
      }"
    >
      <NTable
        id="booking-venues-sidewindow-venue-booking-list"
        class="h1 dbox1"
        :config="tableConfig"
        :headers="headers"
        :items="list"
        :showNoItems="false"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td
              @click.stop="e => onBookingClick(item)"
              v-bind="tdcon('start_date')"
            >
              <span
                class="txtov ut-link ut-text-accent5"
                :title="item['start_date']"
              >
                {{ item["start_date"] }}
              </span>
            </td>
            <td v-bind="tdcon('artist_name')">
              <span class="txtov" :title="item['artist_name']">
                {{ item["artist_name"] }}
              </span>
            </td>
            <td v-bind="tdcon('performance_type')">
              <span class="txtov" :title="item['performance_type']">
                {{ item["performance_type"] }}
              </span>
            </td>
            <td v-bind="tdcon('booking_status_colour')">
              <div class="booking_status_name">
                <span
                  class="circle-status"
                  :style="{
                    backgroundColor: `#${item['booking_status_colour']}`
                  }"
                ></span>
                <span> {{ item["status_name"] }}</span>
              </div>
            </td>

            <td v-bind="tdcon('promoter_name')">
              <span class="txtov" :title="item['promoter_name']">
                {{ item["promoter_name"] }}
              </span>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <!-- <div class="document-table" :v-if="selectedVenue.locations">
      <div class="top-bar">
        <v-flex md4>
          <v-layout row wrap>
            <v-flex md6>
              <v-menu
                :close-on-content-click="false"
                v-model="dateFromMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <TextField
                  slot="activator"
                  :id="'dateFrom'"
                  v-bind="textFieldConfig"
                  v-model="filter.dateFrom"
                  isModel
                  :placeholder="'From'"
                  @startEditing="(e) => (dateFromMenu = e)"
                  @valuechanged="dateChanged"
                ></TextField>

                <v-date-picker
                  v-model="filter.dateFrom"
                  @input="(e) => dateChanged('dateFrom', e)"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex md6>
              <v-menu
                :close-on-content-click="false"
                v-model="dateToMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <TextField
                  slot="activator"
                  :id="'dateTo'"
                  v-bind="textFieldConfig"
                  v-model="filter.dateTo"
                  isModel
                  :placeholder="'To'"
                  @startEditing="(e) => (dateToMenu = e)"
                  @valuechanged="dateChanged"
                ></TextField>

                <v-date-picker
                  v-model="filter.dateTo"
                  @input="(e) => dateChanged('dateTo', e)"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
        <Dropdown
          :options="statusTV"
          v-if="statusTV && statusTV.length > 0"
          :placeholder="$t('status')"
          :selected="filter.selectedStatus"
          v-on:selectedChange="(e) => onDropdownChange('status', e)"
          box
          deselect
        ></Dropdown>
        <Dropdown
          :options="promotersTV"
          v-if="promotersTV && promotersTV.length > 0"
          :placeholder="$t('contact_promoter')"
          :selected="filter.selectedPromoter"
          v-on:selectedChange="(e) => onDropdownChange('promoter', e)"
          box
          deselect
        ></Dropdown>
        <Dropdown
          :options="artistsTV"
          v-if="artistsTV && artistsTV.length > 0"
          :placeholder="$t('artist_filter')"
          :selected="filter.selectedArtist"
          v-on:selectedChange="(e) => onDropdownChange('artist', e)"
          box
          deselect
        ></Dropdown>
      </div>
      <v-data-table
        v-if="selectedVenue.locations && selectedVenue.locations.length > 0"
        :items="selectedVenue.locations"
        :headers="headers"
        :hide-headers="false"
        hide-actions
        class="dt-table dbox-table"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th v-for="header in props.headers" :key="header.value">
              {{ $t(header.text) }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <tr @click="(e) => onBookingClick(props.item)">
            <td class="start_date">
              {{ props.item["start_date"] }}
            </td>
            <td class="artist_name">
              {{ props.item["artist_name"] }}
            </td>
            <td class="performance_type">
              {{ props.item["performance_type"] }}
            </td>
            <td class="booking_status_colour">
              <div
                class="colored-box"
                :style="{
                  'background-color': '#' + props.item['booking_status_colour'],
                }"
              ></div>
            </td>
            <td class="promoter_name">
              {{ props.item["promoter_name"] }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </div> -->
  </DBox>
</template>

<script>
import Dropdown from "@plugins/dropdown/dropdown";
import TextField from "@plugins/text-field/text-field";
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import { DTIconButton } from "../../../../plugins/button/button";
import { bookingListCalendarDateTabRoute } from "../../router/router";
import {
  encodeRoute,
  createMailHref,
  capitalizeFirst
} from "../../../../utility";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { isEmpty } from "ramda";

export default {
  components: {
    DBox,
    NTable,
    DTIconButton,
    Dropdown,
    TextField
  },
  props: {
    selectedVenue: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      dateFromMenu: null,
      dateToMenu: null,
      searchFlag: false,
      filter: {
        artist_id: "",
        from_date: "",
        to_date: "",
        booking_status_id: "",
        promoter_id: ""
      },
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      }),
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false
      }
    };
  },
  computed: {
    list: function() {
      if (
        this.selectedVenue.locations &&
        this.selectedVenue.locations.length > 0
      ) {
        this.selectedVenue.locations = this.selectedVenue.locations.map(l => {
          l.status_name = this.selectedVenue.status.find(
            s => s.booking_status_colour === l.booking_status_colour
          )
            ? this.selectedVenue.status.find(
                s => s.booking_status_colour === l.booking_status_colour
              ).booking_status_name
            : "";
          return l;
        });
      }

      return this.selectedVenue.locations || [];
    },
    headers: function() {
      return [
        createTableHeader("start_date", { text: "related booking", f: 0.7 }),
        createTableHeader("artist_name", { text: "artist" }),
        createTableHeader("performance_type", { text: "type" }),
        createTableHeader("booking_status_colour", {
          text: "status",
          mw: 200
        }),
        createTableHeader("promoter_name", { text: "promoter" })
      ];
    },
    filterExists() {
      return (
        this.filter.artist_id ||
        this.filter.from_date ||
        this.filter.to_date ||
        this.filter.booking_status_id ||
        this.filter.promoter_id
      );
    },
    statusTV: function() {
      return (
        (this.selectedVenue &&
          this.selectedVenue.status &&
          this.selectedVenue.status.map((e, i) => ({
            text: e.booking_status_name,
            value: `${e.booking_status_id}`
          }))) ||
        []
      );
    },
    promotersTV: function() {
      return (
        (this.selectedVenue &&
          this.selectedVenue.promoters &&
          this.selectedVenue.promoters.map((e, i) => ({
            text: e.company_name
              ? e.company_name
              : `${e.first_name} ${e.last_name}`,
            value: `${e.promoter_id}`
          }))) ||
        []
      );
    },
    artistsTV: function() {
      return (
        (this.selectedVenue &&
          this.selectedVenue.artists &&
          this.selectedVenue.artists.map((e, i) => ({
            text: e.artist_name,
            value: `${e.artist_id}`
          }))) ||
        []
      );
    }
  },
  methods: {
    resetFilter() {
      return {
        artist_id: "",
        from_date: "",
        to_date: "",
        booking_status_id: "",
        promoter_id: ""
      };
    },
    onBadgeClick(badge) {
      if (badge == "reset_filters") {
        this.filter = {
          artist_id: "",
          from_date: "",
          to_date: "",
          booking_status_id: "",
          promoter_id: ""
        };
        this.onApplyFilter();
        this.searchFlag = false;
      }
    },
    onSearchClick: function() {
      this.searchFlag = !this.searchFlag;
    },
    onBookingClick: function(booking) {
      this.$router.push({
        name: bookingListCalendarDateTabRoute,
        params: {
          calendar_date_id: booking.calendar_date_id,
          tab: "overview"
        },
        query: {
          from: encodeRoute(this.$route)
        }
      });
    },
    onMailClick: function(mail) {
      location.href = createMailHref({
        mails: [mail]
      });
    },
    onDropdownChange: function(name, value) {
      // if (isEmpty(value)) {
      //   value = undefined;
      // }
      switch (name) {
        case "status": {
          this.filter.booking_status_id = value.value || "";
          break;
        }
        case "promoter": {
          this.filter.promoter_id = value.value || "";
          break;
        }
        case "artist": {
          this.filter.artist_id = value.value || "";
          break;
        }
      }
    },

    dateChanged: function(name, value) {
      this.filter[name] = value;
    },

    onApplyFilter: function() {
      const filter = {
        booking_location_id: this.selectedVenue.location.booking_location_id
          ? this.selectedVenue.location.booking_location_id
          : "",
        ...this.filter
      };
      this.$emit("filter", filter);
    }

    // MARK: Methods
  }
};
</script>

<style lang="scss" scoped>
.cmp-booking-venues-sidewindow-venue-booking {
  .search-controls {
    .dt-input-box {
      border-bottom: 1px solid var(--sprt-5) !important;
    }
    .dropdown {
      margin: 5px;
    }
    .dt-input-box--container {
      margin: 5px !important;
    }
  }
}
.booking_status_name {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 5px;
}
.booking_status_colour {
  flex: 1;
  display: flex;
  align-items: center;
  .circle-status {
    margin-right: 10px;
  }
  .status-name {
    flex: 1;
  }
}
// .dbox-table {
//   --rest-cell-padding: 0px 5px;
//   --header-text-align: left;
//   --th-padding: 0 7px;

//   table {
//     th {
//       padding: 0 7px;
//     }

//     th:nth-child(4),
//     td:nth-child(4) {
//       width: 40px !important;
//       max-width: 40px !important;
//       padding: 0px 7px !important;
//       i {
//         font-size: 14px;
//       }
//     }
//     td:nth-child(4) {
//       padding: 0px 10px !important;
//     }

//     .mail-button,
//     .close-button {
//       padding-top: 7px;
//     }
//     .checkbox-container {
//       display: flex;
//       justify-content: center;
//       margin-top: -4px;
//     }
//   }
// }

// .dt-icon {
//   margin-top: 2px;
// }

// .booking_status_colour {
//   .colored-box {
//     width: 15px;
//     height: 15px;
//   }
// }

// span.partner-name,
// span.promoter-name {
//   padding-top: -50px;
// }

// .top-bar {
//   display: flex;

//   .dropdown {
//     flex: 1;
//     margin: 5px;
//   }
// }
</style>
